export const getRequestMicrosoftUserId = (
): string => {
    const urlParams = new URLSearchParams(window.location.search);

    let userId = urlParams.get('userId');
    return userId;
};
